
__webpack_require__.debugRequireIds = {
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.106.2/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/google-sprite.css": 4598,
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.106.2/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/twitter-sprite.css": 5022,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/google-sprite.css": 83526,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/twitter-sprite.css": 39278,
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 82901,
	"./generated/emoji/google.webp": 94213,
	"./generated/emoji/twitter.webp": 60889,
	"./src/base_page_params.ts": 88585,
	"./src/blueslip.ts": 67463,
	"./src/blueslip_stacktrace.ts": 65047,
	"./src/bot_types.ts": 20154,
	"./src/bundles/common.ts": 48422,
	"./src/csrf.ts": 58315,
	"./src/i18n.ts": 8625,
	"./src/portico/google-analytics.ts": 50762,
	"./src/portico/portico_modals.ts": 60307,
	"./src/portico/tippyjs.ts": 88879,
	"./src/realm_user_settings_defaults.ts": 69757,
	"./src/sentry.ts": 92522,
	"./src/state_data.ts": 39307,
	"./src/stream_types.ts": 12287,
	"./src/types.ts": 97620,
	"./src/user_settings.ts": 56748,
	"./src/user_status_types.ts": 86077,
	"./src/util.ts": 17369,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"altcha": 26971,
	"core-js/modules/es.array-buffer.detached.js": 19000,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 32169,
	"core-js/modules/es.array-buffer.transfer.js": 60025,
	"core-js/modules/es.array.includes.js": 54508,
	"core-js/modules/es.array.push.js": 94361,
	"core-js/modules/es.iterator.constructor.js": 16608,
	"core-js/modules/es.iterator.filter.js": 79944,
	"core-js/modules/es.iterator.find.js": 70001,
	"core-js/modules/es.iterator.map.js": 72542,
	"core-js/modules/es.iterator.some.js": 75390,
	"core-js/modules/es.json.parse.js": 9999,
	"core-js/modules/es.json.stringify.js": 27761,
	"core-js/modules/es.map.get-or-insert-computed.js": 47180,
	"core-js/modules/es.map.get-or-insert.js": 40870,
	"core-js/modules/es.set.difference.v2.js": 93535,
	"core-js/modules/es.set.intersection.v2.js": 2665,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 18052,
	"core-js/modules/es.set.is-subset-of.v2.js": 92025,
	"core-js/modules/es.set.is-superset-of.v2.js": 54402,
	"core-js/modules/es.set.symmetric-difference.v2.js": 36617,
	"core-js/modules/es.set.union.v2.js": 54725,
	"core-js/modules/es.typed-array.with.js": 10722,
	"core-js/modules/es.uint8-array.set-from-base64.js": 61693,
	"core-js/modules/es.uint8-array.set-from-hex.js": 48789,
	"core-js/modules/es.uint8-array.to-base64.js": 33775,
	"core-js/modules/es.uint8-array.to-hex.js": 72791,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"jquery-validation": 9905,
	"lodash": 35558,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 39124,
	"zod/mini": 15729
};